import { createAnalyticsSaga } from 'decentraland-dapps/dist/modules/analytics'
import { CreditsClient } from 'decentraland-dapps/dist/modules/credits/CreditsClient'
import { creditsSaga as createCreditsSaga } from 'decentraland-dapps/dist/modules/credits/sagas'
import { ApplicationName } from 'decentraland-dapps/dist/modules/features'
import { featuresSaga } from 'decentraland-dapps/dist/modules/features/sagas'
import { createProfileSaga } from 'decentraland-dapps/dist/modules/profile/sagas'
import { transactionSaga } from 'decentraland-dapps/dist/modules/transaction/sagas'
import { createTranslationSaga } from 'decentraland-dapps/dist/modules/translation/sagas'
import { createWalletSaga } from 'decentraland-dapps/dist/modules/wallet/sagas'
import { all } from 'redux-saga/effects'

import { config } from '../config/config'

import { identitySaga } from './identity/sagas'

import * as translations from './locales'

const analyticsSaga = createAnalyticsSaga()
const translationSaga = createTranslationSaga({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  translations: translations as any,
})

const profileSaga = () => createProfileSaga({ getIdentity: () => undefined, peerUrl: config.get('PEER_URL') })

const creditsClient = new CreditsClient(config.get('CREDITS_SERVER_URL'))
const creditsSaga = () => createCreditsSaga({ creditsClient })

export function* rootSaga() {
  yield all([
    analyticsSaga(),
    createWalletSaga({
      CHAIN_ID: Number(config.get('CHAIN_ID')),
      POLL_INTERVAL: 0,
      TRANSACTIONS_API_URL: 'https://transactions-api.decentraland.org/v1',
    })(),
    featuresSaga({
      polling: {
        apps: [ApplicationName.DAPPS],
        delay: 60000 /** 60 seconds */,
      },
    }),
    identitySaga(),
    profileSaga(),
    translationSaga(),
    transactionSaga(),
    creditsSaga(),
  ])
}
